import { euiPaletteColorBlindBehindText } from "@inscopix/ideas-eui";
import { TaskStatus } from "./constants";

const colors = euiPaletteColorBlindBehindText({ sortBy: "natural" });

type TColorsByTaskStatus = {
  [status in TaskStatus]: string;
};

export const ColorsByTaskStatus: TColorsByTaskStatus = {
  [TaskStatus.NEW]: colors[8],
  [TaskStatus.QUEUED]: colors[8],
  [TaskStatus.INITIALIZING]: colors[9],
  [TaskStatus.RUNNING]: colors[1],
  [TaskStatus.PAUSED]: colors[2],
  [TaskStatus.COMPLETE]: colors[0],
  [TaskStatus.FAILED]: colors[5],
  [TaskStatus.ERROR]: colors[5],
  [TaskStatus.CANCELED]: colors[7],
  [TaskStatus.PROCESSING]: colors[1],
} as const;
